
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as covidtP9HHyAYtP5KobCBxgT1PqFnnfXkrDVSFqNiE_458T0EwMeta } from "/app/base/pages/covid.vue?macro=true";
import { default as indexK2B78jfyxmRkXDPG0omFkZk2K6x2Mwn12Rf_0vqR_453gMeta } from "/app/base/pages/index.vue?macro=true";
import { default as contact1lqeyXyDCh7cbrg1ACZhaBI_45P8Ci6Wf_45r0XmYToiTTMMeta } from "/app/base/pages/contact.vue?macro=true";
import { default as ui_45componentsLtsLQA1DqOUjmoTwtmZOXcg3TGEujscxSmpi_45WGHGZEMeta } from "/app/base/pages/ui-components.vue?macro=true";
import { default as seite_45nicht_45gefundenkpH0veoeexSQsZLVOc8AAMJO2gNfdU8jR2gXpNJd_45UUMeta } from "/app/base/pages/seite-nicht-gefunden.vue?macro=true";
import { default as indexEGRFLFQqCPZxySb5S1jdnIekNv2RLT9FrqZ5R4LKCgwMeta } from "/app/terminierungsportal/pages/[appointmentId]/index.vue?macro=true";
import { default as ihr_45terminwDIDmFlKTEIuaO18zBll1RXHbj7RvF52JuWKYyvmpDwMeta } from "/app/terminierungsportal/pages/[appointmentId]/ihr-termin.vue?macro=true";
import { default as kontaktdatenyfDZIvHGSF3Ny2mzEaU2j9nlTgG0i7fcRRbhfwt7MXcMeta } from "/app/terminierungsportal/pages/[appointmentId]/kontaktdaten.vue?macro=true";
import { default as termin_45beendetF_45gCtHG6Jb5w7aOQqzqDsrp1Yp5D7Rwp4om9qoQHJ10Meta } from "/app/terminierungsportal/pages/[appointmentId]/termin-beendet.vue?macro=true";
import { default as termin_45abgesagtwlfnv3e3Au2z_9GWM8NNdQ3dwmkl9NBZiNxeNvYvFFYMeta } from "/app/terminierungsportal/pages/[appointmentId]/termin-abgesagt.vue?macro=true";
import { default as termin_45bewertenzHBkP1ubDJi8Y0v9bnmQncKCguP_45I0JVAl6pTi_hc4EMeta } from "/app/terminierungsportal/pages/[appointmentId]/termin-bewerten.vue?macro=true";
import { default as termin_45bewertetLKYzQ25_ysPWVrGFXdju6sHYIPxKfsopurvhcF89sf8Meta } from "/app/terminierungsportal/pages/[appointmentId]/termin-bewertet.vue?macro=true";
import { default as indextty7B6WCa_45_7HbKLuyaOPu2IsChR5uMbi7H4sJ5xlx8Meta } from "/app/feedbackportal/pages/bewertung/[technicianSlug]/index.vue?macro=true";
import { default as abgesagter_45Terminq2R51t53ANgriwbebq7sQKD04wBR0FynTx9MFvtAInIMeta } from "/app/terminierungsportal/pages/[appointmentId]/abgesagter-Termin.vue?macro=true";
import { default as sonstige_45hinweise4WH_45heX41OeensS_45vbNr8Tpt3ASYZEmjnVIpy7NqLC4Meta } from "/app/terminierungsportal/pages/[appointmentId]/sonstige-hinweise.vue?macro=true";
import { default as termin_45bestaetigtPqKrgkBOp44_szYxaD3cjJKS6Kq4_45wN3q6tyRTO3PL4Meta } from "/app/terminierungsportal/pages/[appointmentId]/termin-bestaetigt.vue?macro=true";
import { default as delegierter_45termin0vXwCO5WiJOUwvpnhgWzrklZOUXRdGFkwXenWV9mlDYMeta } from "/app/terminierungsportal/pages/[appointmentId]/delegierter-termin.vue?macro=true";
import { default as neue_45kontaktpersonuk71p726i5JzkPFWZjn0BxlbYjSxH8xakTVB7PDF4FYMeta } from "/app/terminierungsportal/pages/[appointmentId]/neue-kontaktperson.vue?macro=true";
import { default as sicherheitsabfrageXTSkQ9Y7DImZy93GmsOF9kNu5NEbLKlFnueaZCKCMrAMeta } from "/app/terminierungsportal/pages/[appointmentId]/sicherheitsabfrage.vue?macro=true";
import { default as bestaetigter_45terminQ_dwQxB1IU9o8SBBFvVOU8euTdB6iBMnCtoSLGoQpXgMeta } from "/app/terminierungsportal/pages/[appointmentId]/bestaetigter-termin.vue?macro=true";
import { default as verschobener_45termin51aMHSyf0tbQvrHZIlEH_LDX2pOWHLgHix8b7IdH0aUMeta } from "/app/terminierungsportal/pages/[appointmentId]/verschobener-termin.vue?macro=true";
import { default as wunschtermin_45buchenZMC8wALcKdvxYU8Zd22fpUmxr_45qiHQp_QxKjxW2EDuEMeta } from "/app/terminierungsportal/pages/[appointmentId]/wunschtermin-buchen.vue?macro=true";
import { default as stornierter_45termin_45iesjjhmHOVmtOt4BEOfkhua8stTTExAGVnajMDHSIT9KzoMeta } from "/app/terminierungsportal/pages/[appointmentId]/stornierter-termin-ies.vue?macro=true";
import { default as verschobener_45termin_45ieshCbGQcZW4Z0tW2HgXghvJRRRaSHmwtCM8E1kmUnADzQMeta } from "/app/terminierungsportal/pages/[appointmentId]/verschobener-termin-ies.vue?macro=true";
import { default as wunschtermin_45auswaehlenaxYBsiRzqA9VGCnrwv61yCXv7kkiJ6EV4Q5HjJ8gV1oMeta } from "/app/terminierungsportal/pages/[appointmentId]/wunschtermin-auswaehlen.vue?macro=true";
import { default as keine_45termine_45verfuegbarfP5RuhIHEDykhBZknaHSvUYkpGl_LJjV4HpILv5cIbAMeta } from "/app/terminierungsportal/pages/[appointmentId]/keine-termine-verfuegbar.vue?macro=true";
import { default as kontaktdaten_45bestaetigenCq_DkC0OPFmNriZESJbtTRY06O7YcqT25Gbkm1ybl2MMeta } from "/app/terminierungsportal/pages/[appointmentId]/kontaktdaten-bestaetigen.vue?macro=true";
import { default as telefonnummer_45ankuendigungCIBYK3ZcuiD8B5K__45JLvUTwc16qq7Ti0rBcHBQntTnAMeta } from "/app/terminierungsportal/pages/[appointmentId]/telefonnummer-ankuendigung.vue?macro=true";
import { default as termin_45bewerten_45gewinnspiel96By8f2X0V_456P27F91Y9MvThx4xTUN2MkSHc0gpqtVYMeta } from "/app/terminierungsportal/pages/[appointmentId]/termin-bewerten-gewinnspiel.vue?macro=true";
import { default as neue_45kontaktperson_45bestaetigtBORB1vpd6REWibsskUlkToj8Y_45QIepGu3n1oFtLGts8Meta } from "/app/terminierungsportal/pages/[appointmentId]/neue-kontaktperson-bestaetigt.vue?macro=true";
import { default as techniker_45bewertet74KRpFE7W_455KYmYIHsoqQVDs33pO8HH9CYpsbSboepoMeta } from "/app/feedbackportal/pages/bewertung/[technicianSlug]/techniker-bewertet.vue?macro=true";
import { default as neue_45kontaktperson_45bestaetigenpNHxniYv6wLzInc_o_45en4ROXauGiZUrBfYEpIk9NWxcMeta } from "/app/terminierungsportal/pages/[appointmentId]/neue-kontaktperson-bestaetigen.vue?macro=true";
import { default as keine_45verschiebung_45mehr_45moeglichMevyXz0Mzk7UfOYhpDgb2gwwg1AeGqDniWTDSblU_45OAMeta } from "/app/terminierungsportal/pages/[appointmentId]/keine-verschiebung-mehr-moeglich.vue?macro=true";
import { default as nicht_45identifizierbariKRf8CuRSjH3pa4sUQuIV3JG3UcNUf6uVP9Kt_453pDo4Meta } from "/app/feedbackportal/pages/bewertung/[technicianSlug]/nicht-identifizierbar.vue?macro=true";
import { default as keine_45weiteren_45termine_45verfuegbarWROFEBiyuGGm99v6kKI8QYFGXoPJ92V567R_45UBCdOJ8Meta } from "/app/terminierungsportal/pages/[appointmentId]/keine-weiteren-termine-verfuegbar.vue?macro=true";
import { default as kontaktdaten_45gewinnspielAbdwkdkBtXkw3ibsyVfXho6lyXyBj30DhY1Df30i8DgMeta } from "/app/feedbackportal/pages/bewertung/[technicianSlug]/kontaktdaten-gewinnspiel.vue?macro=true";
import { default as wunschtermin_45kontaktdaten_45bestaetigenIkjsT7T9orpgaPvAE63LhOj2CSre8RycxSk5K2Y0dcYMeta } from "/app/terminierungsportal/pages/[appointmentId]/wunschtermin-kontaktdaten-bestaetigen.vue?macro=true";
import { default as telefonnummer_45ankuendigung_45bestaetigenr1lFPu4odyeGwxBAScYyz40lUai84ckCa1NYhC8EVMkMeta } from "/app/terminierungsportal/pages/[appointmentId]/telefonnummer-ankuendigung-bestaetigen.vue?macro=true";
export default [
  {
    name: "covid",
    path: "/covid",
    meta: covidtP9HHyAYtP5KobCBxgT1PqFnnfXkrDVSFqNiE_458T0EwMeta || {},
    component: () => import("/app/base/pages/covid.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/base/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contact1lqeyXyDCh7cbrg1ACZhaBI_45P8Ci6Wf_45r0XmYToiTTMMeta || {},
    component: () => import("/app/base/pages/contact.vue")
  },
  {
    name: "ui-components",
    path: "/ui-components",
    meta: ui_45componentsLtsLQA1DqOUjmoTwtmZOXcg3TGEujscxSmpi_45WGHGZEMeta || {},
    component: () => import("/app/base/pages/ui-components.vue")
  },
  {
    name: "seite-nicht-gefunden",
    path: "/seite-nicht-gefunden",
    meta: seite_45nicht_45gefundenkpH0veoeexSQsZLVOc8AAMJO2gNfdU8jR2gXpNJd_45UUMeta || {},
    component: () => import("/app/base/pages/seite-nicht-gefunden.vue")
  },
  {
    name: "appointmentId",
    path: "/:appointmentId()",
    meta: {"middleware":["appointment-id-guard","auth-guard","appointment-loader"]},
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/index.vue")
  },
  {
    name: "appointmentId-ihr-termin",
    path: "/:appointmentId()/ihr-termin",
    meta: { ...(ihr_45terminwDIDmFlKTEIuaO18zBll1RXHbj7RvF52JuWKYyvmpDwMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/ihr-termin.vue")
  },
  {
    name: "appointmentId-kontaktdaten",
    path: "/:appointmentId()/kontaktdaten",
    meta: { ...(kontaktdatenyfDZIvHGSF3Ny2mzEaU2j9nlTgG0i7fcRRbhfwt7MXcMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/kontaktdaten.vue")
  },
  {
    name: "appointmentId-termin-beendet",
    path: "/:appointmentId()/termin-beendet",
    meta: { ...(termin_45beendetF_45gCtHG6Jb5w7aOQqzqDsrp1Yp5D7Rwp4om9qoQHJ10Meta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/termin-beendet.vue")
  },
  {
    name: "appointmentId-termin-abgesagt",
    path: "/:appointmentId()/termin-abgesagt",
    meta: { ...(termin_45abgesagtwlfnv3e3Au2z_9GWM8NNdQ3dwmkl9NBZiNxeNvYvFFYMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/termin-abgesagt.vue")
  },
  {
    name: "appointmentId-termin-bewerten",
    path: "/:appointmentId()/termin-bewerten",
    meta: { ...(termin_45bewertenzHBkP1ubDJi8Y0v9bnmQncKCguP_45I0JVAl6pTi_hc4EMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/termin-bewerten.vue")
  },
  {
    name: "appointmentId-termin-bewertet",
    path: "/:appointmentId()/termin-bewertet",
    meta: { ...(termin_45bewertetLKYzQ25_ysPWVrGFXdju6sHYIPxKfsopurvhcF89sf8Meta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/termin-bewertet.vue")
  },
  {
    name: "feedbackportal-techniker-bewerten",
    path: "/bewertung/:technicianSlug()",
    meta: { ...(indextty7B6WCa_45_7HbKLuyaOPu2IsChR5uMbi7H4sJ5xlx8Meta || {}), ...{"middleware":["fingerprint-guard","technician-slug-guard","visitor-id-guard"]} },
    component: () => import("/app/feedbackportal/pages/bewertung/[technicianSlug]/index.vue")
  },
  {
    name: "appointmentId-abgesagter-Termin",
    path: "/:appointmentId()/abgesagter-Termin",
    meta: { ...(abgesagter_45Terminq2R51t53ANgriwbebq7sQKD04wBR0FynTx9MFvtAInIMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/abgesagter-Termin.vue")
  },
  {
    name: "appointmentId-sonstige-hinweise",
    path: "/:appointmentId()/sonstige-hinweise",
    meta: { ...(sonstige_45hinweise4WH_45heX41OeensS_45vbNr8Tpt3ASYZEmjnVIpy7NqLC4Meta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/sonstige-hinweise.vue")
  },
  {
    name: "appointmentId-termin-bestaetigt",
    path: "/:appointmentId()/termin-bestaetigt",
    meta: { ...(termin_45bestaetigtPqKrgkBOp44_szYxaD3cjJKS6Kq4_45wN3q6tyRTO3PL4Meta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/termin-bestaetigt.vue")
  },
  {
    name: "appointmentId-delegierter-termin",
    path: "/:appointmentId()/delegierter-termin",
    meta: { ...(delegierter_45termin0vXwCO5WiJOUwvpnhgWzrklZOUXRdGFkwXenWV9mlDYMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/delegierter-termin.vue")
  },
  {
    name: "appointmentId-neue-kontaktperson",
    path: "/:appointmentId()/neue-kontaktperson",
    meta: { ...(neue_45kontaktpersonuk71p726i5JzkPFWZjn0BxlbYjSxH8xakTVB7PDF4FYMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/neue-kontaktperson.vue")
  },
  {
    name: "appointmentId-sicherheitsabfrage",
    path: "/:appointmentId()/sicherheitsabfrage",
    meta: { ...(sicherheitsabfrageXTSkQ9Y7DImZy93GmsOF9kNu5NEbLKlFnueaZCKCMrAMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/sicherheitsabfrage.vue")
  },
  {
    name: "appointmentId-bestaetigter-termin",
    path: "/:appointmentId()/bestaetigter-termin",
    meta: { ...(bestaetigter_45terminQ_dwQxB1IU9o8SBBFvVOU8euTdB6iBMnCtoSLGoQpXgMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/bestaetigter-termin.vue")
  },
  {
    name: "appointmentId-verschobener-termin",
    path: "/:appointmentId()/verschobener-termin",
    meta: { ...(verschobener_45termin51aMHSyf0tbQvrHZIlEH_LDX2pOWHLgHix8b7IdH0aUMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/verschobener-termin.vue")
  },
  {
    name: "appointmentId-wunschtermin-buchen",
    path: "/:appointmentId()/wunschtermin-buchen",
    meta: { ...(wunschtermin_45buchenZMC8wALcKdvxYU8Zd22fpUmxr_45qiHQp_QxKjxW2EDuEMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/wunschtermin-buchen.vue")
  },
  {
    name: "appointmentId-stornierter-termin-ies",
    path: "/:appointmentId()/stornierter-termin-ies",
    meta: { ...(stornierter_45termin_45iesjjhmHOVmtOt4BEOfkhua8stTTExAGVnajMDHSIT9KzoMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/stornierter-termin-ies.vue")
  },
  {
    name: "appointmentId-verschobener-termin-ies",
    path: "/:appointmentId()/verschobener-termin-ies",
    meta: { ...(verschobener_45termin_45ieshCbGQcZW4Z0tW2HgXghvJRRRaSHmwtCM8E1kmUnADzQMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/verschobener-termin-ies.vue")
  },
  {
    name: "appointmentId-wunschtermin-auswaehlen",
    path: "/:appointmentId()/wunschtermin-auswaehlen",
    meta: { ...(wunschtermin_45auswaehlenaxYBsiRzqA9VGCnrwv61yCXv7kkiJ6EV4Q5HjJ8gV1oMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/wunschtermin-auswaehlen.vue")
  },
  {
    name: "appointmentId-keine-termine-verfuegbar",
    path: "/:appointmentId()/keine-termine-verfuegbar",
    meta: { ...(keine_45termine_45verfuegbarfP5RuhIHEDykhBZknaHSvUYkpGl_LJjV4HpILv5cIbAMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/keine-termine-verfuegbar.vue")
  },
  {
    name: "appointmentId-kontaktdaten-bestaetigen",
    path: "/:appointmentId()/kontaktdaten-bestaetigen",
    meta: { ...(kontaktdaten_45bestaetigenCq_DkC0OPFmNriZESJbtTRY06O7YcqT25Gbkm1ybl2MMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/kontaktdaten-bestaetigen.vue")
  },
  {
    name: "appointmentId-telefonnummer-ankuendigung",
    path: "/:appointmentId()/telefonnummer-ankuendigung",
    meta: { ...(telefonnummer_45ankuendigungCIBYK3ZcuiD8B5K__45JLvUTwc16qq7Ti0rBcHBQntTnAMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/telefonnummer-ankuendigung.vue")
  },
  {
    name: "appointmentId-termin-bewerten-gewinnspiel",
    path: "/:appointmentId()/termin-bewerten-gewinnspiel",
    meta: { ...(termin_45bewerten_45gewinnspiel96By8f2X0V_456P27F91Y9MvThx4xTUN2MkSHc0gpqtVYMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/termin-bewerten-gewinnspiel.vue")
  },
  {
    name: "appointmentId-neue-kontaktperson-bestaetigt",
    path: "/:appointmentId()/neue-kontaktperson-bestaetigt",
    meta: { ...(neue_45kontaktperson_45bestaetigtBORB1vpd6REWibsskUlkToj8Y_45QIepGu3n1oFtLGts8Meta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/neue-kontaktperson-bestaetigt.vue")
  },
  {
    name: "techniker-bewertet",
    path: "/bewertung/:technicianSlug()/techniker-bewertet",
    meta: techniker_45bewertet74KRpFE7W_455KYmYIHsoqQVDs33pO8HH9CYpsbSboepoMeta || {},
    component: () => import("/app/feedbackportal/pages/bewertung/[technicianSlug]/techniker-bewertet.vue")
  },
  {
    name: "appointmentId-neue-kontaktperson-bestaetigen",
    path: "/:appointmentId()/neue-kontaktperson-bestaetigen",
    meta: { ...(neue_45kontaktperson_45bestaetigenpNHxniYv6wLzInc_o_45en4ROXauGiZUrBfYEpIk9NWxcMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/neue-kontaktperson-bestaetigen.vue")
  },
  {
    name: "appointmentId-keine-verschiebung-mehr-moeglich",
    path: "/:appointmentId()/keine-verschiebung-mehr-moeglich",
    meta: { ...(keine_45verschiebung_45mehr_45moeglichMevyXz0Mzk7UfOYhpDgb2gwwg1AeGqDniWTDSblU_45OAMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/keine-verschiebung-mehr-moeglich.vue")
  },
  {
    name: "feedbackportal-no-visitor-id",
    path: "/bewertung/:technicianSlug()/nicht-identifizierbar",
    meta: { ...(nicht_45identifizierbariKRf8CuRSjH3pa4sUQuIV3JG3UcNUf6uVP9Kt_453pDo4Meta || {}), ...{"middleware":["fingerprint-guard"]} },
    component: () => import("/app/feedbackportal/pages/bewertung/[technicianSlug]/nicht-identifizierbar.vue")
  },
  {
    name: "appointmentId-keine-weiteren-termine-verfuegbar",
    path: "/:appointmentId()/keine-weiteren-termine-verfuegbar",
    meta: { ...(keine_45weiteren_45termine_45verfuegbarWROFEBiyuGGm99v6kKI8QYFGXoPJ92V567R_45UBCdOJ8Meta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/keine-weiteren-termine-verfuegbar.vue")
  },
  {
    name: "kontaktdaten-gewinnspiel",
    path: "/bewertung/:technicianSlug()/kontaktdaten-gewinnspiel",
    meta: { ...(kontaktdaten_45gewinnspielAbdwkdkBtXkw3ibsyVfXho6lyXyBj30DhY1Df30i8DgMeta || {}), ...{"middleware":["fingerprint-guard","technician-slug-guard"]} },
    component: () => import("/app/feedbackportal/pages/bewertung/[technicianSlug]/kontaktdaten-gewinnspiel.vue")
  },
  {
    name: "appointmentId-wunschtermin-kontaktdaten-bestaetigen",
    path: "/:appointmentId()/wunschtermin-kontaktdaten-bestaetigen",
    meta: { ...(wunschtermin_45kontaktdaten_45bestaetigenIkjsT7T9orpgaPvAE63LhOj2CSre8RycxSk5K2Y0dcYMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/wunschtermin-kontaktdaten-bestaetigen.vue")
  },
  {
    name: "appointmentId-telefonnummer-ankuendigung-bestaetigen",
    path: "/:appointmentId()/telefonnummer-ankuendigung-bestaetigen",
    meta: { ...(telefonnummer_45ankuendigung_45bestaetigenr1lFPu4odyeGwxBAScYyz40lUai84ckCa1NYhC8EVMkMeta || {}), ...{"middleware":["appointment-id-guard","auth-guard","appointment-loader"]} },
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/telefonnummer-ankuendigung-bestaetigen.vue")
  },
  {
    name: "appointmentId-wunschtermin-bestaetigt",
    path: "/:appointmentId/wunschtermin-bestaetigt",
    meta: {"pageName":"Wunschtermin bestätigt","category":"wunschtermin","label":"wunschtermin-bestaetigt","middleware":["appointment-id-guard","auth-guard","appointment-loader"]},
    component: () => import("/app/terminierungsportal/pages/[appointmentId]/termin-bestaetigt.vue")
  }
]